videojs.addLanguage('en', {
  "AdBlockers warning": "Warning",
  "Off adBlockers to watch normaly": function() {
  	let strong = document.createElement("strong");
  	strong.innerHTML = 'a browser extension to block ads';
  	return [document.createTextNode("It looks like you are using "), 
  		strong,
  		document.createTextNode(". The quality of the video will be lowered."), 
  		document.createElement("br"), 
  		document.createElement("br"),
  		document.createTextNode("Disable ad blocker and refresh page for quality control and high-resolution view.")];
  }
});